<app-page-title icon="fa-link" title="Domínio Próprio"></app-page-title>

<app-plan-message></app-plan-message>

<div class="row" *ngIf="!loading && !blocked">
  <div class="col-12 col-lg-8 offset-lg-2">

    <!-- ============ ADMIN: LISTAGEM GERAL ============ -->
    <div class="card" *ngIf="isAdmin && !domain && !adminCreating">
      <div class="card-body">
        <div class="d-flex justify-content-between align-items-center mb-3">
          <h5 class="card-title mb-0">Domínios próprios dos clientes</h5>
          <button type="button" class="sf-btn sf-btn--primary" (click)="startAdminCreate()">
            <i class="fa fa-plus"></i> Novo domínio
          </button>
        </div>

        <p class="text-muted" *ngIf="!adminDomains.length">Nenhum domínio cadastrado ainda.</p>

        <div class="table-responsive" *ngIf="adminDomains.length">
          <table class="table table-sm align-middle">
            <thead>
              <tr>
                <th>Domínio</th>
                <th>Cliente</th>
                <th>Tipo</th>
                <th>Status</th>
                <th>Criado em</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let d of adminDomains">
                <td><code>{{ d.domain }}</code></td>
                <td>{{ d.user?.name || d.user_id }}<br /><small>{{ d.user?.email }}</small></td>
                <td>{{ d.type === 'byod' ? 'BYOD' : 'Compra' }}</td>
                <td>
                  <span class="badge"
                        [class.bg-success]="d.status === STATUS.ACTIVE"
                        [class.bg-secondary]="d.status === STATUS.CANCELLED || d.status === STATUS.TRANSFERRED"
                        [class.bg-warning]="d.status !== STATUS.ACTIVE && d.status !== STATUS.FAILED && d.status !== STATUS.SUSPENDED && d.status !== STATUS.CANCELLED && d.status !== STATUS.EXPIRED && d.status !== STATUS.TRANSFERRED"
                        [class.bg-danger]="d.status === STATUS.FAILED || d.status === STATUS.SUSPENDED || d.status === STATUS.EXPIRED">
                    {{ statusLabel(d) }}
                  </span>
                </td>
                <td>{{ d.created_at | date: 'dd/MM/yyyy' }}</td>
                <td class="text-end">
                  <button type="button" class="sf-btn sf-btn--secondary sf-btn--sm" (click)="selectDomain(d)">
                    <i class="fa fa-cog"></i> Gerenciar
                  </button>
                </td>
              </tr>
            </tbody>
          </table>

          <app-pagination *ngIf="adminTotal > adminPerPage" [currentPage]="adminPage"
            [itemsPerPage]="adminPerPage" [totalItems]="adminTotal"
            (pageChanged)="adminPageChanged($event)"></app-pagination>
        </div>
      </div>
    </div>

    <!-- ============ SEM DOMÍNIO: CONTRATAÇÃO ============ -->
    <div class="card" *ngIf="!domain && (!isAdmin || adminCreating)">
      <div class="card-body">
        <div class="d-flex justify-content-between align-items-center">
          <h5 class="card-title mb-0">Encurtador dedicado com o seu domínio</h5>
          <button *ngIf="isAdmin" type="button" class="sf-btn sf-btn--ghost sf-btn--sm" (click)="backToList()">
            <i class="fa fa-arrow-left"></i> Voltar
          </button>
        </div>
        <p class="text-muted mt-2">
          Todas as URLs curtas das suas automações passam a sair no seu próprio domínio
          (ex.: <strong>links.suamarca.com</strong>) em vez do encurtador compartilhado.
        </p>

        <div *ngIf="isAdmin" class="mb-3">
          <label class="form-label">Cliente (deixe vazio para criar pra você)</label>
          <input type="text" class="form-control" placeholder="Busque por nome ou e-mail (mín. 3 letras)"
                 [formControl]="userControl" [matAutocomplete]="autoUser" (keyup)="filterUsers($event)" />
          <mat-autocomplete requireSelection #autoUser="matAutocomplete" [displayWith]="displayUser">
            <mat-option *ngFor="let u of filteredUsers$ | async" [value]="u">
              {{ displayUser(u) }}
            </mat-option>
          </mat-autocomplete>

          <div class="form-check mt-2" *ngIf="userControl.value">
            <input class="form-check-input" type="checkbox" id="allowWithoutPlan" [(ngModel)]="allowWithoutPlan" />
            <label class="form-check-label" for="allowWithoutPlan">
              Liberar sem assinatura ativa (cliente grande autorizado)
            </label>
          </div>
        </div>

        <div class="sf-btn-group choice-group mb-3" role="group">
          <button type="button" class="sf-btn"
                  [class.is-active]="domainType === 'byod'"
                  [attr.aria-pressed]="domainType === 'byod'"
                  (click)="setDomainType('byod')">
            Já tenho um domínio
          </button>
          <button type="button" class="sf-btn"
                  [class.is-active]="domainType === 'purchase'"
                  [attr.aria-pressed]="domainType === 'purchase'"
                  (click)="setDomainType('purchase')">
            Quero comprar um domínio
          </button>
        </div>

        <div class="input-group mb-3">
          <input type="text" class="form-control" placeholder="links.suamarca.com"
                 [(ngModel)]="domainName" (ngModelChange)="domainNameChanged()"
                 (keyup.enter)="checkAvailability()" />
          <button class="sf-btn sf-btn--secondary" type="button"
                  [appLoadingButton]="isBusy('checkAvailability')"
                  [disabled]="working || !domainName.trim()" (click)="checkAvailability()">
            <i class="fa fa-search"></i> Consultar
          </button>
        </div>

        <div *ngIf="availabilityChecked && availability">
          <div class="alert alert-danger" *ngIf="!availability.available">
            <i class="fa fa-times-circle"></i> {{ availabilityReasonText() }}
          </div>

          <div *ngIf="availability.available">
            <div class="alert alert-success">
              <i class="fa fa-check-circle"></i> Domínio disponível!
            </div>

            <table class="table table-sm">
              <tbody>
                <tr>
                  <td>Add-on domínio próprio (pagamento único)</td>
                  <td class="text-end">R$ {{ availability.pricing.addon.toFixed(2).replace('.', ',') }}</td>
                </tr>
                <tr *ngIf="availability.pricing.domain">
                  <td>Registro do domínio (1 ano)</td>
                  <td class="text-end">R$ {{ availability.pricing.domain.toFixed(2).replace('.', ',') }}</td>
                </tr>
                <tr class="fw-bold">
                  <td>Total</td>
                  <td class="text-end">R$ {{ availability.pricing.total.toFixed(2).replace('.', ',') }}</td>
                </tr>
              </tbody>
            </table>

            <button type="button" class="sf-btn sf-btn--primary sf-btn--block"
                    [appLoadingButton]="isBusy('registerDomain')" [disabled]="working" (click)="registerDomain()">
              Contratar domínio próprio
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- ============ COM DOMÍNIO: STATUS ============ -->
    <div class="card" *ngIf="domain">
      <div class="card-body">
        <div class="d-flex justify-content-between align-items-center mb-3">
          <div>
            <h5 class="card-title mb-0">{{ domain.domain }}</h5>
            <small class="text-muted">
              <span *ngIf="isAdmin && domain.user">Cliente: {{ domain.user.name }} ({{ domain.user.email }}) · </span>
              {{ domain.type === 'byod' ? 'Domínio próprio (BYOD)' : 'Domínio comprado' }} ·
              <span class="badge"
                    [class.bg-success]="domain.status === STATUS.ACTIVE"
                    [class.bg-secondary]="domain.status === STATUS.TRANSFERRED"
                    [class.bg-warning]="domain.status !== STATUS.ACTIVE && domain.status !== STATUS.FAILED && domain.status !== STATUS.SUSPENDED && domain.status !== STATUS.EXPIRED && domain.status !== STATUS.TRANSFERRED"
                    [class.bg-danger]="domain.status === STATUS.FAILED || domain.status === STATUS.SUSPENDED || domain.status === STATUS.EXPIRED">
                {{ statusLabel() }}
              </span>
              <!-- custo REAL da compra, na moeda do registrador — não é a mesma
                   unidade do "repasse estimado (R$)" da tela de preços -->
              <span *ngIf="isAdmin && domain.registrar_cost">
                · Custo no registrador: {{ domain.registrar_cost_currency || 'US$' }}
                {{ domain.registrar_cost.toFixed(2).replace('.', ',') }}
                <span *ngIf="domain.registrar_driver">({{ domain.registrar_driver }})</span>
              </span>
            </small>
          </div>
          <div class="d-flex gap-2">
            <button *ngIf="isAdmin" type="button" class="sf-btn sf-btn--ghost sf-btn--sm" (click)="backToList()">
              <i class="fa fa-arrow-left"></i> Voltar
            </button>
            <button type="button" class="sf-btn sf-btn--secondary sf-btn--sm" [disabled]="loading" (click)="loadDomain()">
              <i class="fa fa-refresh"></i> Atualizar
            </button>
          </div>
        </div>

        <!-- pending_ownership: TXT challenge -->
        <div *ngIf="domain.status === STATUS.PENDING_OWNERSHIP && instructions?.txt_record">
          <p>
            Para provar que o domínio é seu, crie o registro <strong>TXT</strong> abaixo no
            painel de DNS do seu provedor:
          </p>

          <table class="table table-sm table-bordered">
            <thead>
              <tr><th>Tipo</th><th>Nome/Host</th><th>Valor</th></tr>
            </thead>
            <tbody>
              <tr>
                <td>TXT</td>
                <td class="copy-cell">
                  <code>{{ instructions.txt_record.host }}</code>
                  <button type="button" class="sf-btn sf-btn--ghost sf-btn--icon sf-btn--sm ms-2" title="Copiar" aria-label="Copiar"
                          (click)="copy(instructions.txt_record.host, 'Nome/Host do registro TXT copiado!')">
                    <i class="fa fa-copy"></i>
                  </button>
                </td>
                <td class="copy-cell">
                  <code>{{ instructions.txt_record.value }}</code>
                  <button type="button" class="sf-btn sf-btn--ghost sf-btn--icon sf-btn--sm ms-2" title="Copiar" aria-label="Copiar"
                          (click)="copy(instructions.txt_record.value, 'Valor do registro TXT copiado!')">
                    <i class="fa fa-copy"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>

          <button type="button" class="sf-btn sf-btn--primary"
                  [appLoadingButton]="isBusy('verifyOwnership')" [disabled]="working" (click)="verifyOwnership()">
            <i class="fa fa-check"></i> Já criei o registro — verificar posse
          </button>
        </div>

        <!-- pending_payment: checkout da contratação (assinatura de 12 meses) -->
        <div *ngIf="domain.status === STATUS.PENDING_PAYMENT">
          <table class="table table-sm">
            <tbody>
              <tr>
                <td>Assinatura add-on domínio próprio (12 meses)</td>
                <td class="text-end">R$ {{ domain.price_addon?.toFixed(2)?.replace('.', ',') }}</td>
              </tr>
              <tr *ngIf="domain.price_domain">
                <td>Registro do domínio (1 ano)</td>
                <td class="text-end">R$ {{ domain.price_domain.toFixed(2).replace('.', ',') }}</td>
              </tr>
              <tr class="fw-bold">
                <td>Total</td>
                <td class="text-end">R$ {{ domain.price_total?.toFixed(2)?.replace('.', ',') }}</td>
              </tr>
            </tbody>
          </table>

          <ng-container [ngTemplateOutlet]="paymentBox"></ng-container>

          <button *ngIf="isAdmin && domain.user_recharge_id" type="button" class="sf-btn sf-btn--secondary sf-btn--block mt-2"
                  [appLoadingButton]="isBusy('adminApprovePayment')" [disabled]="working" (click)="adminApprovePayment()">
            <i class="fa fa-check"></i> Aprovar pagamento (admin)
          </button>
        </div>

        <!-- box de pagamento (contratação e renovação) -->
        <ng-template #paymentBox>
          <div class="sf-btn-group choice-group mb-3" role="group">
            <button type="button" class="sf-btn"
                    [class.is-active]="paymentType === 'pix'"
                    [attr.aria-pressed]="paymentType === 'pix'"
                    (click)="togglePaymentType('pix')">
              <i class="fa fa-qrcode"></i> PIX
            </button>
            <button type="button" class="sf-btn"
                    [class.is-active]="paymentType === 'credit_card'"
                    [attr.aria-pressed]="paymentType === 'credit_card'"
                    (click)="togglePaymentType('credit_card')">
              <i class="fa fa-credit-card"></i> Cartão de crédito
            </button>
          </div>

          <form [formGroup]="paymentForm" *ngIf="paymentType === 'credit_card'" class="mb-3">
            <div class="mb-2">
              <input type="text" class="form-control" placeholder="Número do cartão"
                     formControlName="card_number" appCreditCard />
            </div>
            <div class="mb-2">
              <input type="text" class="form-control" placeholder="Nome impresso no cartão"
                     formControlName="name" />
            </div>
            <div class="row">
              <div class="col-6">
                <input type="text" class="form-control" placeholder="Vencimento (MM/AAAA)"
                       maxlength="7" formControlName="due_date" (keyup)="formatDueDate()" />
              </div>
              <div class="col-6">
                <input type="text" class="form-control" placeholder="CVV" maxlength="4"
                       formControlName="cvv" />
              </div>
            </div>
          </form>

          <button type="button" class="sf-btn sf-btn--primary sf-btn--block"
                  [appLoadingButton]="isBusy('registerCheckout')" [disabled]="working || !isPaymentValid()" (click)="checkout()">
            {{ isRenewMode ? 'Renovar' : 'Pagar' }} R$ {{ chargeTotal().toFixed(2).replace('.', ',') }}
          </button>
        </ng-template>

        <!-- registering -->
        <div *ngIf="domain.status === STATUS.REGISTERING" class="alert alert-info mb-0">
          <i class="fa fa-spinner fa-spin"></i>
          Estamos registrando o seu domínio. Isso pode levar alguns minutos — clique em "Atualizar" para acompanhar.
        </div>

        <!-- pending_dns: instruções -->
        <div *ngIf="domain.status === STATUS.PENDING_DNS">
          <p *ngIf="domain.type === 'byod'">
            Pagamento confirmado! Agora aponte o seu domínio para o nosso encurtador criando o registro abaixo:
          </p>
          <p *ngIf="domain.type === 'purchase'">
            Domínio registrado! Estamos aguardando a propagação do DNS (pode levar algumas horas).
          </p>

          <table class="table table-sm table-bordered" *ngIf="instructions?.records?.length">
            <thead>
              <tr><th>Tipo</th><th>Nome/Host</th><th>Valor</th></tr>
            </thead>
            <tbody>
              <tr *ngFor="let record of instructions.records">
                <td>{{ record.type }}</td>
                <td class="copy-cell">
                  <code>{{ record.host }}</code>
                  <button type="button" class="sf-btn sf-btn--ghost sf-btn--icon sf-btn--sm ms-2" title="Copiar" aria-label="Copiar"
                          (click)="copy(record.host, 'Nome/Host do registro copiado!')">
                    <i class="fa fa-copy"></i>
                  </button>
                </td>
                <td class="copy-cell">
                  <code>{{ record.value }}</code>
                  <button type="button" class="sf-btn sf-btn--ghost sf-btn--icon sf-btn--sm ms-2" title="Copiar" aria-label="Copiar"
                          (click)="copy(record.value, 'Valor do registro copiado!')">
                    <i class="fa fa-copy"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>

          <div class="alert alert-warning" *ngIf="domain.cloudflare_proxied || instructions?.cloudflare_warning">
            <i class="fa fa-exclamation-triangle"></i>
            Seu domínio parece usar o proxy da Cloudflare (nuvem laranja). Deixe o registro em modo
            <strong>"DNS only"</strong> (nuvem cinza) para o certificado HTTPS ser emitido.
          </div>

          <button type="button" class="sf-btn sf-btn--primary"
                  [appLoadingButton]="isBusy('verifyDns')" [disabled]="working" (click)="verifyDns()">
            <i class="fa fa-check"></i> Verificar apontamento
          </button>
        </div>

        <!-- provisioning_infra -->
        <div *ngIf="domain.status === STATUS.PROVISIONING_INFRA">
          <div class="alert alert-info mb-0">
            <i class="fa fa-cogs"></i>
            Apontamento confirmado! Estamos emitindo o certificado HTTPS e ativando o seu domínio.
            Você será notificado quando estiver pronto — normalmente em até 1 dia útil.
          </div>

          <button *ngIf="isAdmin" type="button" class="sf-btn sf-btn--secondary sf-btn--block mt-3"
                  [appLoadingButton]="isBusy('adminConfirmInfra')" [disabled]="working" (click)="adminConfirmInfra()">
            <i class="fa fa-server"></i> Confirmar infra concluída e ativar (admin)
          </button>
        </div>

        <!-- active -->
        <div *ngIf="domain.status === STATUS.ACTIVE">
          <div class="alert alert-success">
            <i class="fa fa-check-circle"></i>
            Domínio ativo! As URLs curtas das suas automações agora saem em
            <strong>{{ domain.domain }}</strong>.
          </div>

          <p class="mb-2" *ngIf="domain.addon_expires_at">
            Assinatura válida até <strong>{{ domain.addon_expires_at | date: 'dd/MM/yyyy' }}</strong>.
            <span class="text-muted">
              A renovação estende a assinatura por mais 12 meses{{ domain.type === 'purchase' ? ' e renova o registro do domínio' : '' }}.
            </span>
          </p>

          <button *ngIf="!renewing" type="button" class="sf-btn sf-btn--secondary" (click)="startRenewal()">
            <i class="fa fa-refresh"></i> Renovar assinatura
            <span *ngIf="renewalPricing"> — R$ {{ renewalPricing.total.toFixed(2).replace('.', ',') }}</span>
          </button>

          <div *ngIf="renewing" class="mt-3">
            <ng-container [ngTemplateOutlet]="paymentBox"></ng-container>
            <button type="button" class="sf-btn sf-btn--ghost sf-btn--block" (click)="cancelRenewal()">Agora não</button>
          </div>
        </div>

        <!-- expired: assinatura vencida -->
        <div *ngIf="domain.status === STATUS.EXPIRED">
          <div class="alert alert-danger">
            <i class="fa fa-exclamation-circle"></i>
            A assinatura do seu domínio venceu{{ domain.addon_expires_at ? ' em ' + (domain.addon_expires_at | date: 'dd/MM/yyyy') : '' }}.
            Suas URLs voltaram temporariamente para o encurtador compartilhado — os links já enviados
            em <strong>{{ domain.domain }}</strong> continuam funcionando.
            <strong>Renove para reativar imediatamente.</strong>
          </div>

          <table class="table table-sm" *ngIf="renewalPricing">
            <tbody>
              <tr>
                <td>Renovação da assinatura (12 meses)</td>
                <td class="text-end">R$ {{ renewalPricing.addon.toFixed(2).replace('.', ',') }}</td>
              </tr>
              <tr *ngIf="renewalPricing.domain">
                <td>Renovação do registro do domínio (1 ano)</td>
                <td class="text-end">R$ {{ renewalPricing.domain.toFixed(2).replace('.', ',') }}</td>
              </tr>
              <tr class="fw-bold">
                <td>Total</td>
                <td class="text-end">R$ {{ renewalPricing.total.toFixed(2).replace('.', ',') }}</td>
              </tr>
            </tbody>
          </table>

          <ng-container [ngTemplateOutlet]="paymentBox"></ng-container>

          <button *ngIf="isAdmin && domain.user_recharge_id" type="button" class="sf-btn sf-btn--secondary sf-btn--block mt-2"
                  [appLoadingButton]="isBusy('adminApprovePayment')" [disabled]="working" (click)="adminApprovePayment()">
            <i class="fa fa-check"></i> Aprovar pagamento (admin)
          </button>
        </div>

        <!-- transferência de titularidade (Compra): solicitar -->
        <div class="mt-3" *ngIf="canRequestTransfer && !transferring && domain.status !== STATUS.PENDING_PAYMENT">
          <hr />
          <div class="text-end">
            <button type="button" class="sf-btn sf-btn--secondary sf-btn--sm" (click)="startTransfer()">
              <i class="fa fa-exchange"></i>
              Transferir titularidade do domínio — R$ {{ transferPrice.toFixed(2).replace('.', ',') }}
            </button>
          </div>
        </div>

        <div class="mt-3" *ngIf="transferring">
          <hr />
          <div class="alert alert-warning">
            <i class="fa fa-exclamation-triangle"></i>
            Ao transferir, o domínio <strong>{{ domain.domain }}</strong> passa a ser seu no registrador e
            <strong>deixa de funcionar como encurtador na plataforma</strong> — os links já enviados dependerão
            de para onde você apontar o domínio. Após o pagamento, nossa equipe executa a transferência e você
            recebe o código de autorização por e-mail.
          </div>
          <ng-container [ngTemplateOutlet]="paymentBox"></ng-container>
          <button type="button" class="sf-btn sf-btn--ghost sf-btn--block" (click)="cancelTransfer()">Agora não</button>
        </div>

        <!-- transferência em andamento -->
        <div *ngIf="domain.transfer_paid_at && !domain.transferred_at" class="mt-3">
          <div class="alert alert-info mb-0">
            <i class="fa fa-exchange"></i>
            Transferência de titularidade paga — nossa equipe está executando no registrador.
            Você receberá o código de autorização (auth code) por e-mail.
          </div>

          <button *ngIf="isAdmin" type="button" class="sf-btn sf-btn--secondary sf-btn--block mt-3"
                  [appLoadingButton]="isBusy('adminConfirmTransfer')" [disabled]="working" (click)="adminConfirmTransfer()">
            <i class="fa fa-exchange"></i> Confirmar transferência concluída (admin)
          </button>
        </div>

        <!-- transferred -->
        <div *ngIf="domain.status === STATUS.TRANSFERRED" class="alert alert-secondary mb-0">
          <i class="fa fa-check"></i>
          Domínio transferido para a titularidade do cliente
          {{ domain.transferred_at ? 'em ' + (domain.transferred_at | date: 'dd/MM/yyyy') : '' }}.
        </div>

        <!-- suspended -->
        <div *ngIf="domain.status === STATUS.SUSPENDED" class="alert alert-danger mb-0">
          <i class="fa fa-ban"></i>
          Seu domínio está suspenso{{ domain.suspend_reason ? ': ' + domain.suspend_reason : '' }}.
          Suas URLs voltaram temporariamente para o encurtador compartilhado — fale com o suporte.
        </div>

        <!-- failed -->
        <div *ngIf="domain.status === STATUS.FAILED">
          <div class="alert alert-danger">
            <i class="fa fa-times-circle"></i>
            A ativação do domínio falhou{{ domain.failure_reason ? ' (' + domain.failure_reason + ')' : '' }}.
            Fale com o suporte ou cancele para tentar novamente com outro domínio.
          </div>
        </div>

        <div class="mt-3 text-end">
          <button *ngIf="canCancel()" type="button" class="sf-btn sf-btn--danger sf-btn--sm"
                  [appLoadingButton]="isBusy('cancelDomain')" [disabled]="working" (click)="cancelDomain()">
            <i class="fa fa-trash"></i> Cancelar contratação
          </button>
          <button *ngIf="isAdmin && domain.status !== STATUS.CANCELLED" type="button" class="sf-btn sf-btn--danger sf-btn--sm ms-2"
                  [appLoadingButton]="isBusy('adminRemoveDomain')" [disabled]="working" (click)="adminRemoveDomain()">
            <i class="fa fa-trash"></i> Remover domínio (admin)
          </button>
        </div>
      </div>
    </div>

  </div>
</div>

<!-- Esqueleto no lugar do cartão (CU-86akkubzz): a tela saiu do overlay global. -->
<div class="row" *ngIf="loading" data-testid="dominio-proprio-loading">
  <div class="col-12 col-lg-8 offset-lg-2">
    <app-skeleton *ngIf="isAdmin && !domain" variant="table-row" [count]="5" [columns]="5"
      label="Carregando os domínios"></app-skeleton>
    <app-skeleton *ngIf="!isAdmin || domain" variant="card" [count]="2"
      label="Carregando o domínio próprio"></app-skeleton>
  </div>
</div>

<!-- Modal PIX -->
<ng-template #pixModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Pague com PIX</h5>
    <button type="button" class="btn-close" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body text-center">
    <p *ngIf="pixImage"><img [src]="pixImage" class="w-100" /></p>
    <textarea rows="3" class="w-100 form-control text-center" readonly>{{ pixCode }}</textarea>
    <button type="button" (click)="copy(pixCode, 'Código PIX copiado para a área de transferência!')" class="sf-btn sf-btn--primary mt-2">
      <i class="fa fa-copy"></i> Copiar código PIX
    </button>
    <p class="text-muted mt-3 mb-0">
      Assim que o pagamento for confirmado, o próximo passo libera automaticamente.
    </p>
  </div>
</ng-template>
